// import ModalReportSelect from "../../../../../app/project/reports/modal/modal-report-select"; - DO NOT ENABLE Circular dependency ??? see below
import Report from "../../../../../core/model2/report/report";
import ApiProject from "../../../../../core/gd/api/project";
import ProjectSession from "../../../../../core/model2/project/project-session";
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const";

export function menuAdd_initReports(options:Options, disabled: boolean, project?:ProjectSession) {

    const onAddReport = () => {
        addMenu_addReport(project || undefined)
    }


    options.push({
        type        : PopoverMenuItemType.MODAL,
        icon        : 'i5-pie-chart',
        label       : 'Report',
        disabled    : disabled,   // for now same as view setting
        onClick     : onAddReport
    })


}

export function addMenu_addReport(project?:ProjectSession) {

    gd.layout.popovers.closeAll()

    // yes required... import creates circular dependency in here... not sure why and how
    const ModalReportSelect = require("../../../../../app/project/reports/modal/modal-report-select").default

    gd.modal.showV4({
        className       : 'modal-new-version-released',
        component       : ModalReportSelect,
        params          : {

            project     : project,

            onSubmit    : async (report: Report)=>{
                gd.modal.hide()

                try {
                    const response = await ApiProject.newReportView({
                        name            : report.name,
                        parentProjectId : project?.id,    // !!!
                        projectIcon     : "report",
                        properties      : {customViewType  : report.type},
                        settings        : {
                            customView      : {
                                settings        : report.settings,
                                type            : report.type
                            }
                        }
                    }).promise()

                    // open report
                    // gd.navigation.goToProject(response.projectId, "")

                } catch (e) {
                    console.error(e)
                }
            },

        }
    });

}